import moment from "moment"
import { useEffect, useState } from "react"
import { useToast } from "@/components/Common/Toast"
import {
  Accordion,
  Button,
  ButtonGroup,
  Card,
  Col,
  Container,
  Dropdown,
  Form,
  Modal,
  Row,
  Badge,
  Spinner,
} from "react-bootstrap"

import "./visit.css"

import AssignCustomer from "@/components/Customers/AssignCustomer"
import AssignUser from "@/components/Users/AssignUser"
import API from "@/common/API"
import Settings from "@/common/Settings"
import AddEditVisit from "./AddEditVisit"
import { parsedUser } from "@/common/GetCurrentUser"
import { isSuperAdmin } from "@/common/helpers"
import { useHistory } from "react-router-dom"
import ModernImageViewer from "@/components/Common/ModernImageViewer"

import ModernVisitGallery from "../ModernVisitGallery"
import VisitMap from "../VisitMap"
import AddEditPlace from "../AddEditPlace"
import { useTranslation } from "react-i18next"
import AssignPlaceStatus from "./AssignPlaceStatus"
import VisitList from "../VisitList"
import { Routes } from "@/routes"
import VehicleVisit from "../VehicleVisit"
import Summary from "./Summary"
import OchoaDetails from "./OchoaDetails"
import PlaceContactsTab from "@/components/Places/PlaceContactsTab"
import PlaceRemindersTab from "@/components/Places/PlaceRemindersTab"
import PlaceProFormaTab from "@/components/Places/PlaceProFormaTab"
import PlaceFilesTab from "@/components/Places/PlaceFilesTab"
import placeEnhancementsService from "@/services/PlaceEnhancementsService"
import ActivityLogPage from "@/pages/ActivityLogPage"

const VisitDetails = props => {
  const [model, setModel] = useState(props.model)
  const user = parsedUser()
  const canViewCrossOrg = isSuperAdmin(user)
  const [crossOrgMatches, setCrossOrgMatches] = useState([])

  const getInitialSection = () => {
    const hash = window.location.hash.replace("#", "").toLowerCase()
    if (["summary", "contacts", "reminders", "proforma", "files", "shearlybi", "activity"].includes(hash)) {
      return hash
    }
    return "summary"
  }

  const [section, setSection] = useState(getInitialSection)
  const [menuSearch, setMenuSearch] = useState("")

  const handleSelectSection = sec => {
    setSection(sec)
    window.location.hash = `#${sec}`
  }

  useEffect(() => {
    const onHashChange = () => {
      const h = window.location.hash.replace("#", "").toLowerCase()
      if (["summary", "contacts", "reminders", "proforma", "files", "shearlybi", "activity"].includes(h)) {
        setSection(h)
      }
    }
    window.addEventListener("hashchange", onHashChange)
    return () => window.removeEventListener("hashchange", onHashChange)
  }, [])

  const history = useHistory()
  const { t } = useTranslation("global")
  const { success, error } = useToast()
  const [showAssignCustomer, setShowAssignCustomer] = useState(false)
  const [AssignUserType, setAssignUserType] = useState(null)
  const toggleAssignCustomer = () => {
    setShowAssignCustomer(!showAssignCustomer)
    if (showAssignCustomer) {
      requestDetails()
    }
  }
  const [visits, setVisits] = useState([])

  const requestVisits = async () => {
    let query = "placeId=" + model.id
    // query += "&OrganizationId=" + user.OrganizationId;
    let requestAPI = await API.getAction("place/VisitList", query)
    if (requestAPI.data.status === "ok") {
      setVisits(requestAPI.data.response)
    }
  }

  const [totals, setTotals] = useState({
    totalApartments: 0,
    totalRoomsPerApartment: 0,
    totalBathrooms: 0,
    totalHabitableArea: 0,
    totalNonHabitableArea: 0,
  })

  const requestDetails = async () => {
    let query = "id=" + model.id + "&userId=" + user.ID
    // query += "&OrganizationId=" + user.OrganizationId;
    let requestAPI = await API.getAction("place/Details", query)
    if (requestAPI.data.status === "ok") {
      let details = requestAPI.data.response
      setModel(requestAPI.data.response)

      let totalApartments = 0,
        totalRoomsPerApartment = 0,
        totalBathrooms = 0,
        totalHabitableArea = 0,
        totalNonHabitableArea = 0

      totalApartments =
        details.quantityOfFloor * 1 * details.departmentPerFloor * 1
      totalRoomsPerApartment = totalApartments * details.roomsPerApartment * 1

      totalBathrooms = totalRoomsPerApartment * 1.25

      totalHabitableArea =
        details.quantityOfFloor *
        1 *
        details.departmentPerFloor *
        1 *
        details.estimatedDimensions *
        1

      totalNonHabitableArea = totalHabitableArea * 0.2

      setTotals({
        ...totals,
        totalApartments: totalApartments,
        totalRoomsPerApartment: totalRoomsPerApartment,
        totalBathrooms: totalBathrooms,
        totalHabitableArea: totalHabitableArea,
        totalNonHabitableArea: totalNonHabitableArea,
      })
    }
  }

  const [showAddEditVisit, setShowAddEditVisit] = useState(false)
  const toggleAddEditVisit = () => {
    setShowAddEditVisit(!showAddEditVisit)
  }

  const requestCrossOrgMatches = async id => {
    if (!canViewCrossOrg || !id) return
    try {
      const requestAPI = await API.getAction(
        "place/MatchesByLocation",
        `id=${id}`
      )
      if (requestAPI.data.status === "ok") {
        setCrossOrgMatches(requestAPI.data.response || [])
      }
    } catch (ex) {
      console.error("Error fetching cross-org matches:", ex)
    }
  }

  const [isSavingTech, setIsSavingTech] = useState(false)

  const handleTechChange = (field, val) => {
    setModel(prev => ({
      ...prev,
      [field]: val
    }))
  }

  const savePlaceDetails = async () => {
    try {
      setIsSavingTech(true)
      let res = await API.postAction("place/AddEdit", model)
      if (res.data.status === "ok") {
        success("Detalles técnicos actualizados correctamente.")
        requestDetails()
      } else {
        error(res.data.message || "Error guardando detalles.")
      }
    } catch (err) {
      console.error(err)
      error("Error de conexión al guardar.")
    } finally {
      setIsSavingTech(false)
    }
  }

  const formatNumber = val => {
    return new Intl.NumberFormat("es-ES", {
      minimumFractionDigits: 0,
      maximumFractionDigits: 2,
    }).format(val || 0)
  }

  const switchToPlace = async newId => {
    if (!newId) return
    try {
      setIsLoading(true)
      const query = `id=${newId}&userId=${user.ID}`
      const requestAPI = await API.getAction("place/Details", query)
      if (requestAPI.data.status === "ok" && requestAPI.data.response) {
        setModel(requestAPI.data.response)
        setCrossOrgMatches([])
        requestCrossOrgMatches(newId)
      }
    } catch (ex) {
      console.error("Error switching place:", ex)
    } finally {
      setIsLoading(false)
    }
  }

  useEffect(() => {
    if (model) {
      requestVisits()
    }
  }, [model])

  useEffect(() => {
    requestDetails()
  }, [])

  useEffect(() => {
    if (model?.id) {
      requestCrossOrgMatches(model.id)
    }
  }, [model?.id])

  const [showAddEdit, setShowAddEdit] = useState(false)
  const toggleAddEdit = () => {
    setShowAddEdit(!showAddEdit)
    if (showAddEdit) {
      requestDetails()
    }
  }

  const [showAssignUsers, setShowAssignUsers] = useState(false)
  const toggleAssignUsers = type => {
    setShowAssignUsers(!showAssignUsers)
    if (showAssignUsers) {
      requestDetails()
    }
    setAssignUserType(type)
  }
  const [isLoading, setIsLoading] = useState(false)
  const savePlace = async () => {
    try {
      setIsLoading(true)
      let request = await API.postAction("place/AddEdit", model)

      console.log(request)
      if (request.data.status === "ok") {
        success(t("Success"), t("Place saved successfully"))
        requestDetails()
      }
    } catch (ex) {
      console.error(ex)
      error(t("Error"), t("Failed to save place"))
    } finally {
      setIsLoading(false)
    }
  }
  const createChat = async () => {
    try {
      let query = {
        placeId: model.id,
        createdById: user.ID,
      }
      let request = await API.postAction("chat/createChat", query)
      console.log(request)
      if (request) {
        history.push(`/chat/${request.data.response.chatId}`)
      }
    } catch (ex) {
      console.error(ex)
    }
  }
  const [showAssignStatus, setShowAssignStatus] = useState(false)
  const toggleAssignStatus = () => {
    setShowAssignStatus(!showAssignStatus)
    if (showAssignStatus) {
      requestDetails()
    }
  }
  const [showMap, setShowMap] = useState(true)
  const toggleMap = () => {
    setShowMap(!showMap)
  }

  const [showPhoto, setShowPhoto] = useState(true)
  const togglePhoto = () => {
    setShowPhoto(!showPhoto)
  }
  const togglePlacePriority = async (placeId, userId) => {
    try {
      setIsLoading(true)
      let query = `placeId=${placeId}&accountId=${userId}&assignedById=${user.ID}`
      let request = await API.getAction("place/AssignToPriority?" + query)
      if (request.data.status === "ok") {
        requestDetails()
      } else {
        console.error(request.data.response)
      }
    } catch (ex) {
      console.error(ex)
    } finally {
      setIsLoading(false)
    }
  }
  if (!model) {
    return <></>
  }

  return (
    <>
      {/* ADDITIONAL SCREENS  */}
      {showAddEditVisit && (
        <AddEditVisit
          show={showAddEditVisit}
          toggle={toggleAddEditVisit}
          place={model}
        />
      )}
      {showAddEdit && (
        <AddEditPlace show={showAddEdit} toggle={toggleAddEdit} model={model} />
      )}
      {/* {showCategory ? <PhotoCategoryAssign show={showCategory} toggle={toggleShowCategory} PhotoId={selectedPhoto} /> : null} */}
      {showAssignCustomer ? (
        <AssignCustomer
          show={showAssignCustomer}
          toggle={toggleAssignCustomer}
          place={model}
        />
      ) : null}
      {showAssignUsers ? (
        <AssignUser
          show={showAssignUsers}
          toggle={toggleAssignUsers}
          type={AssignUserType}
          place={model}
        />
      ) : null}
      {showAssignStatus ? (
        <AssignPlaceStatus
          show={true}
          toggle={toggleAssignStatus}
          place={model}
        />
      ) : null}
      <Modal
        show={props.show !== undefined ? props.show : true}
        onHide={props.onHide || props.toggle}
        size="xl"
        className="modalRight"
      >
        <Modal.Header closeButton>
          <Row className="mx-0 w-100">
            <Col>
              <div className="d-flex align-items-center">
                <h3 className="mb-0 me-2">{model.name}</h3>

                {/* Status Badge */}
                {/* {model.placeStatus && (
                  <Badge
                    bg="light"
                    text="dark"
                    className="me-2 d-flex align-items-center"
                    style={{ fontSize: "0.8rem" }}
                  >
                    <i
                      className={`${
                        model.placeStatus.icon || "fa fa-circle"
                      } me-1`}
                      style={{ color: model.placeStatus.color }}
                    ></i>
                    {model.placeStatus.name}
                  </Badge>
                )} */}

                {/* Priority Button */}
                <Dropdown as={ButtonGroup} size="sm">
                  <Button
                    variant={
                      model.isInPriority ? "warning" : "outline-secondary"
                    }
                    onClick={() => togglePlacePriority(model.id, user.ID)}
                    disabled={isLoading}
                    title={
                      model.isInPriority
                        ? t("Remove from priority")
                        : t("Add to priority")
                    }
                  >
                    <i className="fa fa-star"></i>
                  </Button>

                  <Dropdown.Toggle
                    split
                    variant={
                      model.isInPriority ? "warning" : "outline-secondary"
                    }
                    id="dropdown-priority"
                  >
                    <i className="fa fa-caret-down"></i>
                  </Dropdown.Toggle>

                  <Dropdown.Menu>
                    <Dropdown.Item
                      onClick={() => toggleAssignUsers("priority")}
                    >
                      <i className="fa fa-user me-2"></i>
                      {t("Assign to user")}
                    </Dropdown.Item>
                  </Dropdown.Menu>
                </Dropdown>
              </div>
            </Col>
            <Col className="text-end">
              <div className="d-flex gap-2 justify-content-end">
                {canViewCrossOrg && (
                  <Dropdown>
                    <Dropdown.Toggle
                      variant="outline-warning"
                      size="sm"
                      id="dropdown-cross-org"
                    >
                      <i className="fas fa-shuffle me-2"></i>
                      <span className="d-none d-md-inline">
                        {t("View in another organization")}
                      </span>
                      <span className="badge bg-warning text-dark ms-2">
                        {crossOrgMatches.length}
                      </span>
                    </Dropdown.Toggle>
                    <Dropdown.Menu align="end">
                      <Dropdown.Header>
                        {t("Same location in other workspaces")}
                      </Dropdown.Header>
                      {crossOrgMatches.length === 0 ? (
                        <Dropdown.ItemText className="text-muted small">
                          {t("No matches in other organizations")}
                        </Dropdown.ItemText>
                      ) : (
                        crossOrgMatches.map(match => (
                          <Dropdown.Item
                            key={match.id}
                            onClick={() => switchToPlace(match.id)}
                          >
                            <div className="fw-bold">
                              {match.organizationName ||
                                t("Unknown organization")}
                            </div>
                            <div className="small text-muted">
                              {match.name || match.id}
                            </div>
                          </Dropdown.Item>
                        ))
                      )}
                    </Dropdown.Menu>
                  </Dropdown>
                )}

                <Button
                  variant="outline-primary"
                  size="sm"
                  onClick={() => toggleAddEdit()}
                  disabled={isLoading}
                >
                  <i className="fa fa-edit me-2"></i>
                  <span className="d-none d-md-inline">{t("Editar Lugar")}</span>
                </Button>

                {section === "shearlybi" && (
                  <>
                    <Button
                      variant={showMap ? "primary" : "outline-secondary"}
                      size="sm"
                      onClick={() => toggleMap()}
                    >
                      <i className="fa fa-map me-2"></i>
                      <span className="d-none d-md-inline">{t("Mapa")}</span>
                    </Button>

                    <Button
                      variant={showPhoto ? "primary" : "outline-secondary"}
                      size="sm"
                      onClick={() => togglePhoto()}
                    >
                      <i className="fa fa-images me-2"></i>
                      <span className="d-none d-md-inline">{t("Fotos")}</span>
                    </Button>
                  </>
                )}

                <Button
                  variant="outline-info"
                  size="sm"
                  onClick={() => createChat()}
                >
                  <i className="fa fa-comments me-2"></i>
                  <span className="d-none d-md-inline">{t("Chat")}</span>
                </Button>
              </div>
            </Col>
          </Row>
        </Modal.Header>
        <Modal.Body className="p-0" style={{ overflow: "auto" }}>
          <Container fluid className="p-0">
            <Row className="g-0">
              {/* LEFT COLUMN: Apple macOS System Settings Style Sidebar */}
              <Col xs={12} md={4} xl={3} className="p-3 macos-sidebar-container">
                {/* Search Bar at top of Sidebar */}
                <div className="position-relative mb-3">
                  <i className="fas fa-magnifying-glass position-absolute text-muted" style={{ left: "10px", top: "9px", fontSize: "0.8rem" }} />
                  <Form.Control
                    size="sm"
                    type="text"
                    placeholder={t("Buscar opciones...")}
                    className="ps-4 border-0 shadow-none bg-white rounded-3"
                    style={{ fontSize: "0.85rem" }}
                    value={menuSearch}
                    onChange={e => setMenuSearch(e.target.value)}
                  />
                </div>

                {/* Place Main Image Banner (Direct static files URL & multi-field fallback) */}
                {(() => {
                  const imgName = model.image || model.image2 || model.photo || model.mainImage
                  const imgUrl = imgName
                    ? (typeof imgName === "string" && (imgName.startsWith("http://") || imgName.startsWith("https://") || imgName.startsWith("data:")))
                      ? imgName
                      : `${Settings.BasePath}files/${imgName}`
                    : null

                  if (imgUrl) {
                    return (
                      <div className="mb-3 rounded-3 overflow-hidden border shadow-sm bg-white">
                        <img loading="lazy"
                          src={imgUrl}
                          alt={model.name || "Imagen de la propiedad"}
                          className="w-100 object-fit-cover"
                          style={{ height: "180px", display: "block" }}
                          onError={e => {
                            const target = e.currentTarget
                            if (!target.dataset.retried && imgName) {
                              target.dataset.retried = "true"
                              target.src = `${Settings.BasePathForAPI}file/getThumbnail?filename=${imgName}`
                            } else {
                              target.style.display = "none"
                            }
                          }}
                        />
                      </div>
                    )
                  }

                  return (
                    <div className="p-2 mb-3 bg-white rounded-3 border shadow-sm text-center">
                      <div className="fw-bold text-dark text-truncate" style={{ fontSize: "0.88rem" }}>{model.name}</div>
                      <small className="text-muted d-block text-truncate" style={{ fontSize: "0.75rem" }}>
                        {model.sector || model.address || "Perfil de Propiedad"}
                      </small>
                    </div>
                  )
                })()}

                {/* Apple macOS Style Sidebar Menu List */}
                <div className="d-flex flex-column gap-1">
                  {/* Group 1: GENERAL Y ASIGNACIÓN */}
                  {(!menuSearch || "resumen general".includes(menuSearch.toLowerCase()) || "contactos".includes(menuSearch.toLowerCase()) || "recordatorios y tareas".includes(menuSearch.toLowerCase())) && (
                    <div className="macos-menu-group-header">GENERAL Y ASIGNACIÓN</div>
                  )}

                  {(!menuSearch || "resumen general".includes(menuSearch.toLowerCase())) && (
                    <button
                      className={`macos-menu-item ${section === "summary" ? "active" : ""}`}
                      onClick={() => handleSelectSection("summary")}
                    >
                      <span className="d-flex align-items-center">
                        <span className="macos-icon-badge" style={{ backgroundColor: "#007AFF" }}>
                          <i className="fas fa-sliders" />
                        </span>
                        Resumen General
                      </span>
                      <i className="fas fa-chevron-right small opacity-50" />
                    </button>
                  )}

                  {(!menuSearch || "contactos".includes(menuSearch.toLowerCase())) && (
                    <button
                      className={`macos-menu-item ${section === "contacts" ? "active" : ""}`}
                      onClick={() => handleSelectSection("contacts")}
                    >
                      <span className="d-flex align-items-center">
                        <span className="macos-icon-badge" style={{ backgroundColor: "#34C759" }}>
                          <i className="fas fa-address-book" />
                        </span>
                        Contactos
                      </span>
                      <Badge bg={section === "contacts" ? "light" : "primary"} text={section === "contacts" ? "dark" : "white"} pill className="ms-auto">
                        {placeEnhancementsService.getContacts(model.id).length}
                      </Badge>
                    </button>
                  )}

                  {(!menuSearch || "recordatorios y tareas".includes(menuSearch.toLowerCase())) && (
                    <button
                      className={`macos-menu-item ${section === "reminders" ? "active" : ""}`}
                      onClick={() => handleSelectSection("reminders")}
                    >
                      <span className="d-flex align-items-center">
                        <span className="macos-icon-badge" style={{ backgroundColor: "#FF9500" }}>
                          <i className="fas fa-bell" />
                        </span>
                        Recordatorios y Tareas
                      </span>
                      {placeEnhancementsService.getAllPendingRemindersCount(model.id) > 0 && (
                        <Badge bg="warning" text="dark" pill className="ms-auto">
                          {placeEnhancementsService.getAllPendingRemindersCount(model.id)}
                        </Badge>
                      )}
                    </button>
                  )}

                  {/* Group 2: COMERCIAL Y ARCHIVOS */}
                  {(!menuSearch || "pro-forma y cuentas".includes(menuSearch.toLowerCase()) || "archivos compartidos".includes(menuSearch.toLowerCase())) && (
                    <div className="macos-menu-group-header">COMERCIAL Y ARCHIVOS</div>
                  )}



                  {(!menuSearch || "archivos compartidos".includes(menuSearch.toLowerCase())) && (
                    <button
                      className={`macos-menu-item ${section === "files" ? "active" : ""}`}
                      onClick={() => handleSelectSection("files")}
                    >
                      <span className="d-flex align-items-center">
                        <span className="macos-icon-badge" style={{ backgroundColor: "#FFCC00" }}>
                          <i className="fas fa-folder-open" />
                        </span>
                        Archivos Compartidos
                      </span>
                      <Badge bg={section === "files" ? "light" : "secondary"} text={section === "files" ? "dark" : "white"} pill className="ms-auto">
                        {placeEnhancementsService.getFiles(model.id).length}
                      </Badge>
                    </button>
                  )}

                  {/* Group 3: MONITOREO Y AUDITORÍA */}
                  {(!menuSearch || "shearly bi (visitas)".includes(menuSearch.toLowerCase()) || "registro de actividad".includes(menuSearch.toLowerCase())) && (
                    <div className="macos-menu-group-header">MONITOREO Y AUDITORÍA</div>
                  )}

                  {(!menuSearch || "shearly bi (visitas)".includes(menuSearch.toLowerCase())) && (
                    <button
                      className={`macos-menu-item ${section === "shearlybi" ? "active" : ""}`}
                      onClick={() => handleSelectSection("shearlybi")}
                    >
                      <span className="d-flex align-items-center">
                        <span className="macos-icon-badge" style={{ backgroundColor: "#AF52DE" }}>
                          <i className="fas fa-camera" />
                        </span>
                        Shearly BI (Visitas)
                      </span>
                      <Badge bg={section === "shearlybi" ? "light" : "info"} text={section === "shearlybi" ? "dark" : "white"} pill className="ms-auto">
                        {visits.length}
                      </Badge>
                    </button>
                  )}

                  {(!menuSearch || "registro de actividad".includes(menuSearch.toLowerCase())) && (
                    <button
                      className={`macos-menu-item ${section === "activity" ? "active" : ""}`}
                      onClick={() => handleSelectSection("activity")}
                    >
                      <span className="d-flex align-items-center">
                        <span className="macos-icon-badge" style={{ backgroundColor: "#8E8E93" }}>
                          <i className="fas fa-history" />
                        </span>
                        Registro de Actividad
                      </span>
                      <i className="fas fa-chevron-right small opacity-50" />
                    </button>
                  )}
                </div>

                {/* Point 7 Fix: Add Visit Button resaltado con color primario #007AFF */}
                <div className="mt-4 pt-3 border-top">
                  <Button
                    variant="primary"
                    size="sm"
                    className="w-100 py-2 fw-bold text-white shadow-sm rounded-3"
                    style={{ backgroundColor: "#007AFF", borderColor: "#007AFF" }}
                    onClick={() => toggleAddEditVisit()}
                  >
                    <i className="fa fa-plus me-2" />
                    Agregar Visita
                  </Button>
                </div>
              </Col>

              {/* RIGHT COLUMN: macOS Settings Style Active Section Panel */}
              <Col xs={12} md={8} xl={9} className="p-4 macos-panel-container">
                {/* macOS Settings Section Banner Header */}
                <div className="macos-header-card d-flex align-items-center justify-content-between mb-4">
                  <div className="d-flex align-items-center gap-3">
                    <div
                      className="rounded-3 text-white d-flex align-items-center justify-content-center shadow-sm"
                      style={{
                        width: "48px",
                        height: "48px",
                        backgroundColor:
                          section === "summary" ? "#007AFF" :
                          section === "contacts" ? "#34C759" :
                          section === "reminders" ? "#FF9500" :
                          section === "proforma" ? "#30B0C7" :
                          section === "files" ? "#FFCC00" :
                          section === "shearlybi" ? "#AF52DE" : "#8E8E93",
                        fontSize: "1.3rem"
                      }}
                    >
                      <i className={
                        section === "summary" ? "fas fa-sliders" :
                        section === "contacts" ? "fas fa-address-book" :
                        section === "reminders" ? "fas fa-bell" :
                        section === "proforma" ? "fas fa-file-invoice-dollar" :
                        section === "files" ? "fas fa-folder-open" :
                        section === "shearlybi" ? "fas fa-camera" : "fas fa-history"
                      } />
                    </div>
                    <div>
                      <h5 className="fw-bold mb-0 text-dark">
                        {section === "summary" && t("Resumen General")}
                        {section === "contacts" && t("Contactos")}
                        {section === "reminders" && t("Recordatorios y Tareas")}
                        {section === "proforma" && t("Pro-Forma y Cuentas")}
                        {section === "files" && t("Archivos Compartidos")}
                        {section === "shearlybi" && t("Shearly BI (Visitas)")}
                        {section === "activity" && t("Registro de Actividad")}
                      </h5>
                      <small className="text-muted">
                        {section === "summary" && t("Ficha de asignación, estado operativo, métricas del inmueble y ubicación.")}
                        {section === "contacts" && t("Personal clave, funciones y canales directos de comunicación.")}
                        {section === "reminders" && t("Seguimiento de tareas, compromisos pendientes y fechas límite de la organización.")}
                        {section === "proforma" && t("Vinculación con cliente ERP y estimaciones financieras pro-forma.")}
                        {section === "files" && t("Planos de arquitectura, contratos, pliegos y especificaciones compartidas.")}
                        {section === "shearlybi" && t("Registro visual de campo, inspecciones fotográficas y mapa de visitas.")}
                        {section === "activity" && t("Traza completa de auditoría e historial de eventos del sistema.")}
                      </small>
                    </div>
                  </div>
                </div>

                {/* SUMMARY SECTION */}
                {section === "summary" && (
                  <div>
                    {/* Executive Assignment & Status Card */}
                    <Card className="border shadow-sm mb-4 rounded-3">
                      <Card.Header className="bg-white fw-bold d-flex align-items-center justify-content-between py-2 border-bottom">
                        <span>
                          <i className="fas fa-shield-halved text-primary me-2" />
                          {t("Ficha de Asignación y Estado Operativo")}
                        </span>
                        <div className="d-flex gap-2">
                          {model.stage && <Badge bg="success">{model.stage.name}</Badge>}
                          {model.category && <Badge bg="info">{model.category.name}</Badge>}
                          {model.placeStatus && (
                            <Badge bg="secondary" style={{ backgroundColor: model.placeStatus.color }}>
                              {model.placeStatus.name}
                            </Badge>
                          )}
                        </div>
                      </Card.Header>
                      <Card.Body className="small">
                        <Row className="g-3">
                          <Col md={6} lg={4}>
                            <div className="text-muted fw-semibold mb-1">{t("Assigned to")}</div>
                            {model.assignedTo ? (
                              <Button variant="outline-primary" size="sm" onClick={() => toggleAssignUsers()} className="w-100 text-truncate rounded-3">
                                <i className="fa fa-user me-2" />
                                {model.assignedToObj?.firstName} {model.assignedToObj?.lastName}
                              </Button>
                            ) : (
                              <Button variant="primary" size="sm" onClick={() => toggleAssignUsers()} className="w-100 rounded-3">
                                <i className="fa fa-plus me-2" />
                                {t("Assign")}
                              </Button>
                            )}
                          </Col>

                          <Col md={6} lg={4}>
                            <div className="text-muted fw-semibold mb-1">{t("Reasign Visit")}</div>
                            {model.revisitTo ? (
                              <Button variant="outline-warning" size="sm" onClick={() => toggleAssignUsers("revisit")} className="w-100 text-truncate rounded-3">
                                <i className="fa fa-redo me-2" />
                                {model.revisitTo.firstName} {model.revisitTo.lastName}
                              </Button>
                            ) : (
                              <Button variant="outline-secondary" size="sm" onClick={() => toggleAssignUsers("revisit")} className="w-100 rounded-3">
                                <i className="fa fa-redo me-2" />
                                {t("Assign")}
                              </Button>
                            )}
                          </Col>

                          <Col md={6} lg={4}>
                            <div className="text-muted fw-semibold mb-1">{t("Customer")}</div>
                            {model.customer ? (
                              <div className="d-flex align-items-center gap-1">
                                <Button
                                  variant="outline-info"
                                  size="sm"
                                  className="w-100 text-truncate rounded-3"
                                  onClick={() => history.push(`${Routes.CustomerDetails.clean}${model.customer.id}`)}
                                >
                                  <i className="fa fa-building me-1" />
                                  {model.customer.name}
                                </Button>
                              </div>
                            ) : (
                              <Button variant="outline-secondary" size="sm" onClick={() => toggleAssignCustomer()} className="w-100 rounded-3">
                                <i className="fa fa-link me-2" />
                                {t("Link")}
                              </Button>
                            )}
                          </Col>

                          <Col md={6} lg={4}>
                            <div className="text-muted fw-semibold mb-1">{t("Date of creation")}</div>
                            <div className="p-2 bg-light rounded-3 text-muted">
                              <i className="fa fa-calendar me-2 text-primary" />
                              {moment(model.created).format("DD/MM/YYYY HH:mm")}
                            </div>
                          </Col>

                          <Col md={6} lg={4}>
                            <div className="text-muted fw-semibold mb-1">{t("Created by")}</div>
                            <div className="p-2 bg-light rounded-3 text-muted text-truncate">
                              <i className="fa fa-user-check me-2 text-success" />
                              {model.createdBy ? `${model.createdBy.firstName} ${model.createdBy.lastName}` : "Sistema"}
                            </div>
                          </Col>
                        </Row>
                      </Card.Body>
                    </Card>

                    {/* Technical Details Form Card */}
                    <Card className="border shadow-sm mb-4 rounded-3">
                      <Card.Header className="bg-white fw-bold d-flex align-items-center justify-content-between py-2 border-bottom">
                        <span>
                          <i className="fas fa-sliders text-primary me-2" />
                          Detalles técnicos
                        </span>
                      </Card.Header>
                      <Card.Body>
                        <Row className="g-3">
                          <Col xs={12} md={6}>
                            <Form.Label className="fw-semibold small text-muted">Cantidad de Pisos</Form.Label>
                            <Form.Control
                              type="number"
                              size="sm"
                              className="rounded-3"
                              value={model.quantityOfFloor || ""}
                              onChange={e => handleTechChange("quantityOfFloor", e.target.value)}
                              min="0"
                            />
                          </Col>

                          <Col xs={12} md={6}>
                            <Form.Label className="fw-semibold small text-muted">Apto. por piso</Form.Label>
                            <Form.Control
                              type="number"
                              size="sm"
                              className="rounded-3"
                              value={model.departmentPerFloor || ""}
                              onChange={e => handleTechChange("departmentPerFloor", e.target.value)}
                              min="0"
                            />
                          </Col>

                          <Col xs={12} md={6}>
                            <Form.Label className="fw-semibold small text-muted">Habitaciones por apt.</Form.Label>
                            <Form.Control
                              type="number"
                              size="sm"
                              className="rounded-3"
                              value={model.roomsPerApartment || ""}
                              onChange={e => handleTechChange("roomsPerApartment", e.target.value)}
                              min="0"
                            />
                          </Col>

                          <Col xs={12} md={6}>
                            <Form.Label className="fw-semibold small text-muted">Dimensiones Estimadas (mt2)</Form.Label>
                            <Form.Control
                              type="number"
                              size="sm"
                              className="rounded-3"
                              value={model.estimatedDimensions || ""}
                              onChange={e => handleTechChange("estimatedDimensions", e.target.value)}
                              min="0"
                              step="0.01"
                            />
                          </Col>

                          <Col xs={12} md={6}>
                            <Form.Label className="fw-semibold small text-muted">Código de Cliente</Form.Label>
                            <Form.Control
                              type="text"
                              size="sm"
                              className="rounded-3"
                              value={model.creditCode || ""}
                              onChange={e => handleTechChange("creditCode", e.target.value)}
                            />
                          </Col>
                        </Row>
                      </Card.Body>
                      <Card.Footer className="bg-light d-flex align-items-center justify-content-between py-2">
                        <Button
                          variant="outline-primary"
                          size="sm"
                          className="px-3 fw-semibold rounded-3"
                          onClick={() => handleSelectSection("proforma")}
                        >
                          <i className="fas fa-file-invoice-dollar me-2" />
                          Generar Pro-Forma
                        </Button>
                        <Button
                          variant="primary"
                          size="sm"
                          className="px-4 fw-semibold rounded-3"
                          onClick={savePlaceDetails}
                          disabled={isSavingTech}
                        >
                          {isSavingTech ? (
                            <>
                              <Spinner animation="border" size="sm" className="me-2" />
                              Guardando...
                            </>
                          ) : (
                            <>
                              <i className="fa fa-save me-2" />
                              Guardar
                            </>
                          )}
                        </Button>
                      </Card.Footer>
                    </Card>

                    {/* Estimated Volumetry Card */}
                    {totals.totalApartments > 0 && (
                      <Card className="border shadow-sm mb-4 rounded-3">
                        <Card.Header className="bg-white fw-bold py-2 border-bottom">
                          <i className="fas fa-cubes text-info me-2" />
                          Tabla de Volumetría Estimada
                        </Card.Header>
                        <Card.Body className="small">
                          <Row className="g-3 text-center">
                            <Col xs={6} md={4}>
                              <div className="p-2 bg-light rounded-3">
                                <div className="text-muted small">Unidades Apto.</div>
                                <div className="fw-bold text-primary fs-6">{formatNumber(totals.totalApartments)}</div>
                              </div>
                            </Col>
                            <Col xs={6} md={4}>
                              <div className="p-2 bg-light rounded-3">
                                <div className="text-muted small">Habitaciones</div>
                                <div className="fw-bold text-dark fs-6">{formatNumber(totals.totalRoomsPerApartment)}</div>
                              </div>
                            </Col>
                            <Col xs={6} md={4}>
                              <div className="p-2 bg-light rounded-3">
                                <div className="text-muted small">Est. Baños</div>
                                <div className="fw-bold text-dark fs-6">{formatNumber(totals.totalBathrooms)}</div>
                              </div>
                            </Col>
                            <Col xs={6} md={6}>
                              <div className="p-2 bg-light rounded-3">
                                <div className="text-muted small">Área Habitable (mt2)</div>
                                <div className="fw-bold text-success fs-6">{formatNumber(totals.totalHabitableArea)}</div>
                              </div>
                            </Col>
                            <Col xs={12} md={6}>
                              <div className="p-2 bg-light rounded-3">
                                <div className="text-muted small">Área No Habitable (mt2)</div>
                                <div className="fw-bold text-secondary fs-6">{formatNumber(totals.totalNonHabitableArea)}</div>
                              </div>
                            </Col>
                          </Row>
                        </Card.Body>
                      </Card>
                    )}

                    {/* Technical Specs & Sales Charts */}
                    <Summary model={model} />
                  </div>
                )}

                {/* CONTACTS SECTION */}
                {section === "contacts" && (
                  <Card className="border shadow-sm rounded-3">
                    <Card.Body>
                      <PlaceContactsTab placeId={model.id} />
                    </Card.Body>
                  </Card>
                )}

                {/* REMINDERS SECTION */}
                {section === "reminders" && (
                  <Card className="border shadow-sm rounded-3">
                    <Card.Body>
                      <PlaceRemindersTab placeId={model.id} />
                    </Card.Body>
                  </Card>
                )}

                {/* PRO-FORMA SECTION */}
                {section === "proforma" && (
                  <Card className="border shadow-sm rounded-3">
                    <Card.Body>
                      <PlaceProFormaTab placeId={model.id} placeName={model.name} placeModel={model} />
                    </Card.Body>
                  </Card>
                )}

                {/* FILES SECTION */}
                {section === "files" && (
                  <Card className="border shadow-sm rounded-3">
                    <Card.Body>
                      <PlaceFilesTab placeId={model.id} />
                    </Card.Body>
                  </Card>
                )}

                {/* SHEARLY BI SECTION */}
                {section === "shearlybi" && (
                  <>
                    <div className="d-flex align-items-center justify-content-between mb-4">
                      <div>
                        <h5 className="mb-1 d-flex align-items-center">
                          <i className="fa fa-camera me-2 text-primary" />
                          {t("Visitas e Inspecciones")}
                        </h5>
                        <p className="text-muted mb-0 small">
                          {visits.length > 0
                            ? `${visits.length} ${visits.length === 1 ? t("Registered visit") : t("Registered visits")}`
                            : t("No registered visits")}
                        </p>
                      </div>
                      {visits.length > 0 && (
                        <Badge bg="primary" className="d-flex align-items-center">
                          <i className="fa fa-images me-1" />
                          {visits.length}
                        </Badge>
                      )}
                    </div>

                    <div className="visits-instagram-container">
                      <VisitList visits={visits} />
                    </div>

                    <VehicleVisit id={model.id} />

                    {showPhoto && (
                      <Card className="my-4 shadow-sm rounded-3">
                        <Card.Body className="p-0">
                          <ModernVisitGallery id={model.id} />
                        </Card.Body>
                      </Card>
                    )}

                    {showMap && <VisitMap model={model} />}
                  </>
                )}

                {/* ACTIVITY LOG SECTION */}
                {section === "activity" && (
                  <Card className="border shadow-sm rounded-3">
                    <Card.Body>
                      <ActivityLogPage embedded compact initialSearch={model.id} />
                    </Card.Body>
                  </Card>
                )}
              </Col>
            </Row>
          </Container>
        </Modal.Body>
        <Modal.Footer className="p-1"></Modal.Footer>
      </Modal>
    </>
  )
}

export default VisitDetails
